import React from 'react';

function Spinner({ color = 'white' }) {
  return (
    <span
      className={`h-4 w-4 animate-spin rounded-full border-2 border-${color} border-t-transparent`}
    />
  );
}

export default Spinner;
